import stateListeners from './state-listeners';
import forgottenPasswordEmailFactory from './forgotten-password-email';
import goToLoginPage from '../onboarding-sms/go-to-login-page';
import hasErrorFactory from '../add-company/has-error';
import sendNewPasswordFactory from './send-new-password';
import recaptchaFactory from './../onboarding/recaptcha-functions';
import validatePasswordsMatchFactory from '../onboarding/validate-passwords-match';
import checkSMSFactory from './check-sms';
export default function (app) {
	app.controller('forgotPassword', ['$scope', '$state', 'BaseService', 'COMMON_CONSTS', 'pageContext', 'vcRecaptchaService', '$timeout', 'UserService',
		function ($scope, $state, BaseService, COMMON_CONSTS, pageContext, vcRecaptchaService, $timeout, UserService) {
			var ctrl = this;
			ctrl.userData = {};
			ctrl.smsCountDownSeconds = 60 * 5;
			ctrl.smsForm = {};
			ctrl.smsCode = '';
			ctrl.serviceNotAvailable = false;
			ctrl.showBlockedUserDisclaimer = false;

			ctrl.pageContext = pageContext;
			ctrl.phoneNumber = pageContext.phoneNumber;
			ctrl.userData.userName = pageContext.userName;
			if (!window.location.hash) {
				$state.go('forgotPassword.emailForm');
			}
			ctrl.vcRecaptchaService = vcRecaptchaService;
			ctrl.recaptcha = recaptchaFactory(ctrl);
			ctrl.Formdata = {email : ctrl.pageContext.email || '' };
			ctrl.token = ctrl.pageContext.token;
			ctrl.BaseService = BaseService;
			ctrl.COMMON_CONSTS = COMMON_CONSTS;
			ctrl.emailRegexp = COMMON_CONSTS.EMAIL_REGEXP;
			ctrl.$state = $state;
			ctrl.$timeout = $timeout;
			ctrl.forgottenPasswordEmail = forgottenPasswordEmailFactory(ctrl);
			ctrl.hasError = hasErrorFactory(ctrl);
			ctrl.tryAnotherEmail = () => { ctrl.$state.go('forgotPassword.emailForm'); };
			ctrl.askEmailAgain = () => { ctrl.$state.go('forgotPassword.emailForm'); };
			ctrl.sendNewPassword = sendNewPasswordFactory(ctrl);
			ctrl.validatePasswordsMatch = validatePasswordsMatchFactory();
			ctrl.captchaRequired = pageContext.captcha;
			ctrl.goToLoginPage = goToLoginPage;
			ctrl.checkSMS = checkSMSFactory(ctrl, UserService);
			stateListeners(ctrl);
		}]);
};
